import React, {Component} from 'react';

class TaxTag extends Component {

    static propTypes = {}

    render() {

        return (
            <span className="tax-tag">zzgl. USt.*</span>
        )

    }

}

export default TaxTag



/** WEBPACK FOOTER **
 ** ./src/components/TaxTag.js
 **/